<template>
    <div class="bg-white rounded shadow  container-box">
        <div class="row">
            <div class="col-md-12">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div class="dro col-lg-9 pl-0">
                        <button type="button"
                                class="btn btn-light btn-sm  mb-1"
                                @click.prevent="backToPreviousPage()">
                            <i class="material-icons mdc-button__icon">arrow_back</i>
                            <span>{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
                        </button>
                        <h4 class="dro__title">{{'report.conflict_sessions_title' | trans}} #{{sessionId}}</h4>
                    </div>
                </div>
            </div>


            <div class="col-md-12 mt-2">
                <div :class="{'without_btn': hasPager}">

                    <table-view
                        :options="options"
                        :isLoaded=isLoaded>

                    </table-view>

                </div>
            </div>

            <dashboard-menu  :hideDroModal=hideDroModal></dashboard-menu>
        </div>
    </div>
</template>

<script>
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import axios from 'axios';
  import Manager from '../../dro/api/Manager';
  import {mapGetters, mapState} from 'vuex';
  import isEmpty from 'lodash/isEmpty';
  import Loader from '../../loader/components/Loader';
  import {pagination} from '../../../common/mixins/pagination';
  import lang from '../../../lang/translator';
  import TableView from '../../../common/table/components/TableView';
  import moment from 'moment';

  export default {
    components: {Loader, TableView, DashboardMenu},
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
      'sessionId': {
        type: [Number, String],
        default() {
          return null;
        },
      }
    },
    data() {
      return {
        loaded: false,
        hideDroModal: true,
        apiUrl: '/users/clients/',
        conflictedUrl: '/protocols/assigned/',
        client: {},
        conflicts: [],
        isLoaded: true,
        hasPager: false,
        options: {
          pageHeader: 'conflicts',
          initialPage: null,
          filterable: false,
          sortable: [],
          skin: 'table table-sm table-with-head',
          columns: [
            {
              key: 'name',
              changed: false,
              headings: lang.get('report.stimul'),
            },
            {
              key: 'title',
              changed: false,
              headings: lang.get('protocol.response'),
            },
            {
              key: 'phaseTypeId',
              changed: false,
              headings: lang.get('protocol.phase'),
            },
            {
              key: 'fieldIndex',
              changed: false,
              headings: lang.get('protocol.field'),
            },
            {
              key: 'intervalTypeId',
              changed: false,
              headings: lang.get('protocol.interval'),
            },

          ],
          templates: {
            title: this.title,
            fieldIndex: this.fieldName,
            phaseTypeId: this.phaseNameByTypeId,
            intervalTypeId: this.intervalNameByTypeId
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.items,
              count: resp.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
                'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses: {
            name: 'wrapp-all w40',
            title: 'text-center',
            phaseTypeId: 'text-center',
            fieldIndex: 'text-center',
            intervalTypeId: 'text-center',
          },
          perPage: 20,
        },
      };
    },
    mixins: [pagination],
    created() {
      this.baseUrl = process.env.APP_URL + '/interactive-modules/dro';
      this.getClient(this.clientId);
    },
    computed: {
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      isEmptyconflicts: function() {
        return isEmpty(this.conflicts);
      },
    },
    methods: {
      backToPreviousPage() {
        this.$router.push({name: 'client-edit', params: {clientId: this.clientId}});
      },
      getClient: async function (clientId) {
        try {
          let response = await axios.get(this.apiUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        }
      },
      toLocaleDateTime: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
      },


      title(h, row) {
        return lang.get(row.title);
      },

      phaseNameByTypeId: function (h, row) {
        let name = '';
        switch (parseInt(row.phaseTypeId)) {
          case 0:
            name = lang.get('protocol.all_phases');
            break;
          case 1:
            name = lang.get('protocol.mastering');
            break;
          case 2:
            name = lang.get('protocol.rotation');
            break;
          case 3:
            name = lang.get('protocol.support');
            break;
          case 4:
            name = lang.get('protocol.fluency');
            break;
          default:
            name = lang.get('protocol.no_data');

        }
        return name;
      },

      intervalNameByTypeId: function (h, row) {
        let name = '';
        switch (parseInt(row.intervalTypeId)) {
          case 1:
            name = lang.get('protocol.through_each_lesson');
            break;
          case 2:
            name = lang.get('protocol.after_one_lesson');
            break;
          case 3:
            name = lang.get('protocol.after_two_classes');
            break;
          case 4:
            name = lang.get('protocol.after_three_classes');
            break;
          case 5:
            name = lang.get('protocol.once_a_week');
            break;
          case 6:
            name = lang.get('protocol.once_every_two_weeks');
            break;
          case 7:
            name = lang.get('protocol.once_a_month');
            break;
          default:
            name = lang.get('protocol.no_data');
            break;

        }
        return name;
      },

      fieldName(h, row) {
        return row.fieldIndex ? lang.get('protocol.field') + ' ' + row.fieldIndex : lang.get('protocol.no_data');
      },

      async requestFunction(data) {
        let assigneeId = this.route.params.clientId;
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'conflicts');
        return this.fetchConflicts(assigneeId, this.sessionId, this.options.perPage, data.page);
      },

      getConflicts(assigneeId, sessionId, perPage, page) {
        return axios.get(this.conflictedUrl + assigneeId + '/inconsistent/stimuli/' + sessionId + `/${perPage}/${page}`);
      },

      fetchConflicts: async function(assigneeId, sessionId, perPage, page) {
        try {
          this.isLoaded = false;
          let response = await this.getConflicts(assigneeId, sessionId, perPage, page);

          this.hasPager = response.data.data.lastPage > 1;

          this.conflicts = response.data.data.items;
          this.setPaginate(response.data.data);
          this.isLoaded = true;

          return response.data.data;
        } catch (error) {
          console.dir(error);
          this.isLoaded = true;
        }
      },

      onPaginationClick(pageNum) {
        let assigneeId = this.route.params.clientId;
        this.fetchConflicts(assigneeId, this.paginate.perPage, pageNum);
        this.onPaginationBtnClick(pageNum);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ConflictLayout.vue